import systemEvent from "./const/systemEvent";

const idTokenCookie = "idToken";
const indexPath = "/";
const loginPath = "/login";
const refreshTokenCookie = "refreshToken";
const tokenExpiryGapMinutes = 10;
const userAttributeMap = {
  email: "email",
  given_name: "givenName",
  family_name: "surname",
};

class Adapter {
  constructor(dependencyHash) {
    const {
      axios,
      Cookies,
      env,
      eventBus,
      jwtDecode,
      window,
    } = dependencyHash;

    this.axios = axios;
    this.Cookies = Cookies;
    this.env = env;
    this.eventBus = eventBus;
    this.jwtDecode = jwtDecode;
    this.window = window;
  }

  getXClientSubdomain() {
    if ("undefined" === typeof this.xClientSubdomain) {
      const hostname = this.window.location.hostname;
      const uiBaseDomain = this.env.UI_BASE_DOMAIN;
      this.xClientSubdomain = hostname.substring(0, hostname.indexOf(uiBaseDomain) - 1);
    }

    return this.xClientSubdomain;
  }

  checkIfIdTokenValid() {
    const token = this.Cookies.get(idTokenCookie);
    let tokenValid = false;

    if (token) {
      const decodedToken = this.jwtDecode(token);
      const differenceInMiliseconds = ((decodedToken.exp * 1000) - new Date().getTime());
      const differenceInMinutes = Math.floor(differenceInMiliseconds / 60000);
      if (tokenExpiryGapMinutes <= differenceInMinutes) {
        tokenValid = true;
      }
    }

    return tokenValid;
  }

  invalidateIdToken(redirected = true) {
    this.Cookies.remove(idTokenCookie);

    if (redirected) {
      this.window.location.href = loginPath;
    }
  }

  invalidateRefreshToken() {
    this.Cookies.remove(refreshTokenCookie);
  }

  invalidateTokenSet(redirected = true) {
    this.invalidateRefreshToken();
    this.invalidateIdToken(redirected);
  }

  enforceUserAuthStrategy(route, invalidAuthRedirected = true) {
    const routePath = route.path;
    const loginRouteAccessed = (loginPath === routePath);
    const idTokenValid = this.checkIfIdTokenValid();

    if (idTokenValid) {
      const token = this.Cookies.get(idTokenCookie);
      const decodedToken = this.jwtDecode(token);
      const sessionUser = {};

      Object.keys(userAttributeMap).forEach((tokenAttributeKey) => {
        const userAttributeKey = userAttributeMap[tokenAttributeKey];
        const userAttributeValue = decodedToken[tokenAttributeKey];
        if (userAttributeValue) {
          sessionUser[userAttributeKey] = userAttributeValue;
        }
      });

      this.eventBus.$emit(systemEvent.AUTH_STRATEGY_ENFORCEMENT_DONE, sessionUser);

      if (loginRouteAccessed) {
        this.window.location.href = indexPath;
      }
    } else {
      this.eventBus.$emit(systemEvent.AUTH_STRATEGY_ENFORCEMENT_DONE);
      this.invalidateIdToken(invalidAuthRedirected && !loginRouteAccessed);
    }
  }

  getIdToken() {
    return this.Cookies.get(idTokenCookie);
  }

  getRefreshToken() {
    return this.Cookies.get(refreshTokenCookie);
  }

  setIdToken(tokenValue) {
    this.Cookies.set(idTokenCookie, tokenValue);
  }

  setRefreshToken(tokenValue) {
    this.Cookies.set(refreshTokenCookie, tokenValue);
  }
}

export default {
  Adapter,
  indexPath,
  loginPath,
  tokenExpiryGapMinutes,
};
